import { checkDate } from "common/helpers/Date";
import { Nullable } from "common/types";
import { Record, Map, fromJS, List } from "immutable";

export const webhookEventfromJSON = (json: Partial<IWebhookEventData>): WebhookEventRecord => {
  const record: IWebhookEventRecord = { ...(json as any) };

  if (json.payload) record.payload = fromJS(json.payload);
  if (json.tries) record.tries = fromJS(json.tries);

  if (json.created_at) record.created_at = checkDate(json.created_at);
  if (json.updated_at) record.updated_at = checkDate(json.updated_at);

  return new WebhookEventRecord(record);
};

export interface AttemptData {
  status: number;
  attempted_at: string;
  endpoint: string;
  auth_type: string;
  body: string;
  headers: {
    allow: string;
    date: string;
    content_type: string;
    server: string;
    content_length: string;
    x_xss_protection: string;
    x_frame_options: string;
    alt_svc: string;
  };
}

export interface IWebhookEventData {
  id: string;
  webhook_id: string;
  payload: any;
  tries: {
    attempts: Array<AttemptData>;
  } | null;
  status: string;
  created_at: string;
  updated_at: string;
}

export interface IWebhookEventRecord {
  id: string;
  webhook_id: string;
  payload: Nullable<Map<string, any>>;
  tries: Nullable<Map<"attempts", List<Map<string, any>>>>;
  status: string;
  created_at: Date;
  updated_at: Date;
}

export const defaultWebhookEventProps = {
  id: "",
  webhook_id: "",
  payload: null,
  tries: null,
  status: "",
  created_at: new Date(),
  updated_at: new Date(),
};

export class WebhookEventRecord
  extends Record<IWebhookEventRecord>(defaultWebhookEventProps)
  implements IWebhookEventRecord {}

export const webhookEventLatestAttempt = (webhookEvent: WebhookEventRecord): Nullable<Map<any, any>> => {
  if (webhookEvent.tries && webhookEvent.tries.get("attempts")) {
    return webhookEvent.tries.get("attempts")?.reduce((latest: Map<any, any>, current: Map<any, any>) => {
      const currentTimestamp = new Date(current.get("attempted_at")).getTime();
      const latestTimestamp = new Date(latest.get("attempted_at")).getTime();
      return currentTimestamp > latestTimestamp ? current : latest;
    });
  } else return null;
};
